module.exports = __webpack_public_path__ + "static/media/FUN88_Affiliate_Page_Flygram_Icon.672ea15a.jpg";